import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { makeStyles } from '@material-ui/styles';
import { Link } from "react-router-dom";

import { COLOR_PALETTE } from "./Constants";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1
  },
  title: {
    flexGrow: 1,
  },
  navLink: {
    textDecoration: 'none',
    color: 'rgba(255, 255, 255, 0.5)',
    marginLeft: '25px',
    fontSize: '14px',
    letterSpacing: '0.05em',
    transition: 'opacity 0.3s ease',
    '&:hover': {
      color: 'rgba(255, 255, 255, 0.9)',
    }
  },
  homeLink: {
    textDecoration: 'none',
    color: '#fff',
    fontFamily: "'Space Grotesk', sans-serif",
    fontSize: '20px',
    fontWeight: 500,
    letterSpacing: '-0.01em',
  },
}));

const theme = createTheme({
  palette: {
    primary: {
      main: COLOR_PALETTE.primary,
    }
  }
});

export default function Navbar() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ThemeProvider theme={theme}>
        <AppBar
          position="static"
          color="primary"
          elevation={0}
          style={{ background: 'transparent' }}
        >
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              <Link className={classes.homeLink} to='/'>
                improvta
              </Link>
            </Typography>
            <Link className={classes.navLink} to='/about'>About</Link>
            <Link className={classes.navLink} to='/contact'>Contact</Link>
          </Toolbar>
        </AppBar>
      </ThemeProvider>
    </div>
  );
}
